import api from './api';

export const blogService = {
  // Get all blogs (internal)
  getAllBlogs: async (filters = {}) => {
    const response = await api.get('/blogs', { params: filters });
    return response.data;
  },

  // Get public blogs (for public page)
  getPublicBlogs: async () => {
    const response = await api.get('/blogs/public');
    return response.data;
  },

  // Get single blog
  getBlog: async (id) => {
    const response = await api.get(`/blogs/${id}`);
    return response.data;
  },

  // Get blog by slug
  getBlogBySlug: async (slug) => {
    const response = await api.get(`/blogs/slug/${slug}`);
    return response.data;
  },

  // Create blog
  createBlog: async (blogData) => {
    const response = await api.post('/blogs', blogData);
    return response.data;
  },

  // Update blog
  updateBlog: async (id, blogData) => {
    const response = await api.put(`/blogs/${id}`, blogData);
    return response.data;
  },

  // Submit for approval
  submitBlog: async (id) => {
    const response = await api.patch(`/blogs/${id}/submit`);
    return response.data;
  },

  // Approve blog
  approveBlog: async (id, makePublic) => {
    const response = await api.patch(`/blogs/${id}/approve`, { makePublic });
    return response.data;
  },

  // Reject blog
  rejectBlog: async (id, reason) => {
    const response = await api.patch(`/blogs/${id}/reject`, { reason });
    return response.data;
  },

  // Publish blog
  publishBlog: async (id, makePublic) => {
    const response = await api.patch(`/blogs/${id}/publish`, { makePublic });
    return response.data;
  },

  // Add comment
  addComment: async (id, comment) => {
    const response = await api.post(`/blogs/${id}/comment`, { comment });
    return response.data;
  },

  // Toggle like
  toggleLike: async (id) => {
    const response = await api.patch(`/blogs/${id}/like`);
    return response.data;
  },

  // Delete blog
  deleteBlog: async (id) => {
    const response = await api.delete(`/blogs/${id}`);
    return response.data;
  },

  // Get statistics
  getBlogStats: async () => {
    const response = await api.get('/blogs/stats');
    return response.data;
  }
};
